import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import {
  ClipboardList,
  Mail,
  MessageCircleMore,
  SquarePen,
} from 'lucide-react';

import permissions from '../../../../config/permissions';
import { checkPermission, ellipsisString } from '../../../../utils/Helpers';
import NotificationDropdownWithTabs from '../NotificationDropdownWithTabs';
import { Notifications } from '../../../../constants/notification.constant';

export const checkCRMPermission = () => {
  const crm_module = JSON.parse(
    localStorage.getItem('client_details')
  )?.crm_module;
  return (
    checkPermission(permissions.clients.menu) &&
    crm_module === 1 &&
    (checkPermission(permissions.pullDownMenu.crmClient) ||
      checkPermission(permissions.pullDownMenu.crmLeads) ||
      checkPermission(permissions.pullDownMenu.crmQuotes) ||
      checkPermission(permissions.pullDownMenu.crmInvoices) ||
      checkPermission(permissions.pullDownMenu.crmPayments))
  );
};
export const getEmailTabs = (
  mapEmailNotificationsList,
  emailCount,
  crmEmailList,
  crmEmailCount,
  projectEmailPermission
) => {
  const mapEmailNotificationsListData = mapEmailNotificationsList();
  const emailTabs = [];
  let label = '';
  const hasCRMPermission = checkCRMPermission();
  if (
    projectEmailPermission === true &&
    mapEmailNotificationsListData &&
    mapEmailNotificationsListData.length > 0
  ) {
    emailTabs.push({
      label: 'Project',
      content: mapEmailNotificationsListData.map((item, idx) =>
        item.template ? (
          item.template()
        ) : (
          <div
            className="p-2 text-center font-italic font-bold text-400"
            key={idx}
          >
            {item.label || ''}
          </div>
        )
      ),
    });
    label = `Project Email: ${emailCount}`;
  }

  if (hasCRMPermission === true && crmEmailList && crmEmailList?.length > 0) {
    emailTabs.push({
      label: 'CRM',
      content: crmEmailList.map((item, idx) =>
        item.template ? (
          item.template()
        ) : (
          <div
            className="p-2 text-center font-italic font-bold text-400"
            key={idx}
          >
            {item.label || ''}
          </div>
        )
      ),
    });
    label =
      label.length > 1
        ? `${label} | CRM Email: ${crmEmailCount}`
        : `CRM Email: ${crmEmailCount}`;
  }

  return emailTabs?.length > 0 ? (
    <NotificationDropdownWithTabs
      icon={<Mail size={20} />}
      label={label}
      notificationsLength={emailCount + crmEmailCount}
      tabs={emailTabs}
      className="text-primary-500"
    />
  ) : null;
};

export const getSMSTabs = (
  mapSmsNotificationsList,
  smsCount,
  mapCRMSMSNotificationsList,
  crmSMSCount,
  projectSMSPermission
) => {
  const mapSmsNotificationsListData = mapSmsNotificationsList();
  const smsTabs = [];
  let label = '';
  if (
    projectSMSPermission === true &&
    mapSmsNotificationsListData &&
    mapSmsNotificationsListData.length > 0
  ) {
    smsTabs.push({
      label: 'Project',
      content: mapSmsNotificationsListData.map((item, idx) =>
        item.template ? (
          item.template()
        ) : (
          <div
            className="p-2 text-center font-italic font-bold text-400"
            key={idx}
          >
            {item.label || ''}
          </div>
        )
      ),
    });
    label = `Project SMS: ${smsCount}`;
  }
  if (
    checkCRMPermission() === true &&
    mapCRMSMSNotificationsList &&
    mapCRMSMSNotificationsList.length > 0
  ) {
    smsTabs.push({
      label: 'CRM',
      content: mapCRMSMSNotificationsList.map((item, idx) =>
        item.template ? (
          item.template()
        ) : (
          <div
            className="p-2 text-center font-italic font-bold text-400"
            key={idx}
          >
            {item.label || ''}
          </div>
        )
      ),
    });
    label =
      label.length > 1
        ? `${label} | CRM SMS: ${crmSMSCount}`
        : `CRM SMS: ${crmSMSCount}`;
  }
  return smsTabs?.length > 0 ? (
    <NotificationDropdownWithTabs
      icon={<MessageCircleMore size={20} />}
      label={label}
      notificationsLength={smsCount + crmSMSCount}
      tabs={smsTabs}
      className="text-orange-500"
    />
  ) : null;
};

export const getInstallerStoreNotesTabs = (
  mapInstallerNotifications,
  mapStoreNotificationsList,
  installerNoteCount,
  storeCount
) => {
  const mapInstallerNotificationsData = mapInstallerNotifications();
  const mapStoreNotificationsData = mapStoreNotificationsList();
  const installerStoreTabs = [];
  let label = '';
  if (
    mapInstallerNotificationsData &&
    mapInstallerNotificationsData?.length > 0
  ) {
    if (checkPermission(permissions.pullDownMenu.installerNotes)) {
      installerStoreTabs.push({
        label: 'Installer',
        content: mapInstallerNotifications().map((item, idx) =>
          item.template ? (
            item.template()
          ) : (
            <div
              className="p-2 text-center font-italic font-bold text-400"
              key={idx}
            >
              {item.label || ''}
            </div>
          )
        ),
      });
      label = `Installer: ${installerNoteCount}`;
    }
  }
  if (mapStoreNotificationsData && mapInstallerNotificationsData?.length > 0) {
    if (checkPermission(permissions.pullDownMenu.storeNotes)) {
      installerStoreTabs.push({
        label: 'Store',
        content: mapStoreNotificationsData.map((item, idx) =>
          item.template ? (
            item.template()
          ) : (
            <div
              className="p-2 text-center font-italic font-bold text-400"
              key={idx}
            >
              {item.label || ''}
            </div>
          )
        ),
      });
      label =
        label.length > 1
          ? `${label} | Store: ${storeCount}`
          : `Store: ${storeCount}`;
    }
  }
  return installerStoreTabs?.length > 0 ? (
    <NotificationDropdownWithTabs
      icon={<ClipboardList size={20} />}
      label={label}
      notificationsLength={installerNoteCount + storeCount}
      tabs={installerStoreTabs}
      className="text-purple-500"
    />
  ) : null;
};

export const getCustomerCommunicationTabs = (
  customerPortalEnabled,
  hasCxNotesViewPermission,
  customerChatsList,
  crmNotesList,
  crmNotesCount,
  customerNotesList,
  customerNotesCount
) => {
  const notesTabs = [];
  const crmNotesListData = crmNotesList;
  const customerNotesData = customerNotesList;
  let label = '';
  if (
    customerPortalEnabled &&
    hasCxNotesViewPermission &&
    customerChatsList?.templateList?.length > 0
  ) {
    notesTabs.push({
      label: 'Chats',
      content: customerChatsList?.templateList?.map((item, idx) =>
        item.template ? (
          item.template()
        ) : (
          <div
            className="p-2 text-center font-italic font-bold text-400"
            key={idx}
          >
            {item.label || ''}
          </div>
        )
      ),
    });
    label = `Customer Chat: ${customerChatsList?.count}`;
  }
  if (
    checkPermission(permissions.pullDownMenu.customerNotes) &&
    customerNotesData?.length > 0
  ) {
    notesTabs.push({
      label: 'Notes',
      content: customerNotesList.map((item, idx) =>
        item.template ? (
          item.template()
        ) : (
          <div
            className="p-2 text-center font-italic font-bold text-400"
            key={idx}
          >
            {item.label || ''}
          </div>
        )
      ),
    });
    label =
      label.length > 1
        ? `${label} | Customer Notes: ${customerNotesCount}`
        : `Customer Notes: ${customerNotesCount}`;
  }
  if (checkCRMPermission() && crmNotesListData?.length > 0) {
    notesTabs.push({
      label: 'CRM',
      content: crmNotesList?.map((item, idx) =>
        item.template ? (
          item.template()
        ) : (
          <div
            className="p-2 text-center font-italic font-bold text-400"
            key={idx}
          >
            {item.label || ''}
          </div>
        )
      ),
    });
    label =
      label.length > 1
        ? `${label} | CRM Notes: ${crmNotesCount}`
        : `CRM Notes: ${crmNotesCount}`;
  }

  return notesTabs?.length > 0 ? (
    <NotificationDropdownWithTabs
      icon={<SquarePen size={20} />}
      label={label}
      notificationsLength={
        customerChatsList?.count + crmNotesCount + customerNotesCount
      }
      tabs={notesTabs}
      className="text-green-500"
      severity="success"
    />
  ) : null;
};

export const getSubType = crmData => {
  const { opportunity_id, quote_id, invoice_id, payment_id } = crmData;

  if (!opportunity_id && !quote_id && !invoice_id && !payment_id) return 1;
  if (opportunity_id && !quote_id && !invoice_id && !payment_id) return 2;
  if (opportunity_id && quote_id && !invoice_id && !payment_id) return 3;
  if (opportunity_id && quote_id && invoice_id && !payment_id) return 4;
  if (opportunity_id && quote_id && invoice_id && payment_id) return 5;
  return 0;
};

const renderCRMNotesTemplate = (data, extra) => {
  return data.isEmpty ? (
    <div
      className="flex px-3 py-2 align-items-center"
      key={'notify_' + data.source + '_' + data.id}
    >
      <div className="px-3 text-xs">
        <strong>No new notifications</strong>
      </div>
    </div>
  ) : (
    <>
      <div
        className={`flex pl-3 py-2 align-items-center w-12 border-bottom-1 border-200 ${
          Number(data.is_read) ? 'bg-white' : 'surface-100'
        }`}
        key={'notify_' + data.source + '_' + data.id}
      >
        <div className="text-xs col-7 p-0 pr-2">
          {data.customer !== null ? (
            <p className="mb-0 mt-1">
              <i className="pi pi-user mr-2 text-xs"></i>{' '}
              <strong>
                {Notifications.SUBTYPEMAPPING[getSubType(data)]} | Cust. Name:{' '}
                {data.customer}
              </strong>
              <div className="text-xs col-12 p-0 pr-2">
                <i className="pi pi-send mr-2 text-xs"></i>
                {ellipsisString(data.note, 45)}
              </div>
            </p>
          ) : (
            ''
          )}
        </div>
        <div className="flex col-5 pl-0 justify-content-end">
          <Button
            onClick={() =>
              extra.handleCRMNotesClick(data.customer_id, data.id, 'review')
            }
            label="Review"
            className="text-xs p-1 focus:shadow-none"
            outlined
          />
          <Button
            onClick={() =>
              extra.handleCRMNotesClick(data.customer_id, data.id, 'read')
            }
            severity="primary"
            label="View"
            className="text-xs p-1 focus:shadow-none ml-2"
          />
        </div>
      </div>
      <div
        className={`${
          parseInt(data.index) == parseInt(data.length - 1)
            ? 'block  flex justify-content-center surface-200 p-2'
            : 'hidden'
        }`}
      >
        <Button
          size="small"
          outlined
          severity="info"
          className="py-1 px-2"
          onClick={extra.loadMoreCRMNotesHandler}
          disabled={
            Number(extra.crmNotesCount) === Number(extra.totalCRMNotesCount)
          }
        >
          Load more
          {extra.isLoading ? (
            <i
              className="pi pi-spin pi-spinner ml-2"
              style={{ fontSize: '10px' }}
            ></i>
          ) : (
            ''
          )}
        </Button>
      </div>
    </>
  );
};

export const mapCRMNotes = (
  crmNotesList,
  handleCRMNotesClick,
  loadMoreCRMNotesHandler,
  disabledLoadMore,
  totalCRMNotesCount,
  crmNotesCount,
  isLoading
) => {
  const extra = {
    handleCRMNotesClick,
    loadMoreCRMNotesHandler,
    disabledLoadMore,
    totalCRMNotesCount,
    crmNotesCount,
    isLoading,
  };
  const data =
    crmNotesList && crmNotesList?.length > 0
      ? crmNotesList?.map((row, index) => {
          const data = {
            isEmpty: false,
            source: 'crm_note',
            id: row?.customerNotesId,
            from: row?.name,
            customer: `${row?.customer_first_name} ${row?.customer_last_name}`,
            note: row?.notes,
            is_read: row?.is_read,
            project_id: 0,
            index: index,
            length: crmNotesList?.length,
            customer_id: row?.customer_id,
            opportunity_id: row?.opportunity_id,
            quote_id: row?.quote_id,
            invoice_id: row?.invoice_id,
            payment_id: row?.payment_id,
          };
          return {
            template: () => {
              return renderCRMNotesTemplate(data, extra);
            },
          };
        })
      : [
          {
            icon: 'pi pi-search',
            label: 'No result found',
          },
        ];
  return data;
};

// #### Email notification start

const renderEmailTemplate = (data, extra) => {
  return data.isEmpty ? (
    <div
      className="flex px-3 py-2 align-items-center"
      key={'notify_' + data.source + '_' + data.id}
    >
      <div className="px-3 text-xs">
        <strong>No new notifications</strong>
      </div>
    </div>
  ) : (
    <>
      <div
        className={`flex px-2 py-2 align-items-center w-12 border-bottom-1 border-200 ${
          Number(data.is_read) ? 'bg-white' : 'surface-100'
        }`}
        key={'notify_' + data.source + '_' + data.id}
      >
        <div className="col-1 pl-0 text-xs">
          <Badge
            value={data.total_email ? data.total_email : '0'}
            severity="secondary"
          ></Badge>
        </div>
        <div className="text-xs col-6 p-0 pr-1">
          {data.fromName !== 'null null' ? (
            <>
              <i className="pi pi-send mr-2 text-xs"></i>
              <strong>
                {Notifications.SUBTYPEMAPPING[getSubType(data)]} |Sent From:
                {data.fromName}
              </strong>
            </>
          ) : (
            ''
          )}
          {data.toName !== 'null null' ? (
            <>
              <p className="mb-0 mt-1">
                <i className="pi pi-user mr-2 text-xs"></i>Cust. Name:{' '}
                {data.toName}
              </p>
            </>
          ) : (
            ''
          )}
        </div>
        <div className="col-4 pl-0">
          <Button
            onClick={() => extra.handleCRMEmailClick(data.message_id, 'review')}
            label="Review"
            className="text-xs p-1 focus:shadow-none"
            outlined
          />
          <Button
            onClick={() => extra.handleCRMEmailClick(data.message_id, 'read')}
            label="View"
            className="text-xs p-1 focus:shadow-none ml-2"
          />
        </div>
        <div className="flex px-3 pb-3 text-xs">
          {data.subject && data.subject === null ? (
            <div className="col-12 p-0">Subject: {data.subject}</div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div
        className={`${
          parseInt(data.index) == parseInt(data.length - 1)
            ? 'block  flex justify-content-center surface-200 p-2'
            : 'hidden'
        }`}
      >
        <Button
          size="small"
          outlined
          severity="info"
          className="py-1 px-2"
          onClick={extra.loadMoreEmailHandler}
          disabled={Number(extra.emailCount) === Number(extra.totalEmailCount)}
        >
          Load more
          {extra.emailLoading ? (
            <i
              className="pi pi-spin pi-spinner ml-2"
              style={{ fontSize: '10px' }}
            ></i>
          ) : (
            ''
          )}
        </Button>
      </div>
    </>
  );
};

export const mapCRMEmailNotificationsList = (
  crmEmailList,
  handleCRMEmailClick,
  loadMoreEmailHandler,
  disabledLoadMore,
  emailCount,
  totalEmailCount,
  emailLoading
) => {
  const extra = {
    handleCRMEmailClick,
    loadMoreEmailHandler,
    disabledLoadMore,
    emailCount,
    totalEmailCount,
    emailLoading,
  };
  const data =
    crmEmailList && crmEmailList?.length > 0
      ? crmEmailList?.map((row, index) => {
          const data = {
            isEmpty: false,
            source: 'crm_email',
            client_id: row?.client_id,
            fromName: row?.fromName ?? row?.LastEmail?.from[0]?.name,
            toName:
              row?.toName ??
              `${row?.customer_first_name} ${row?.customer_last_name}`,
            subject: row?.subject,
            total_email: row?.total_email,
            project_id: row?.project_id,
            id: row?.id,
            message_id: row?.id,
            is_read: row?.LastEmail?.read,
            index: index,
            length: crmEmailList?.length,
            customer_id: row?.customer_id,
            opportunity_id: row?.opportunity_id,
            quote_id: row?.quote_id,
            invoice_id: row?.invoice_id,
            payment_id: row?.payment_id,
          };
          return {
            template: () => {
              return renderEmailTemplate(data, extra);
            },
          };
        })
      : [
          {
            icon: 'pi pi-search',
            label: 'No email found',
          },
        ];
  return data;
};

// #### Email notification end

// #### SMS notification start  ----------------

const renderSmsTemplate = (data, extra) => {
  return data.isEmpty ? (
    <div
      className="flex px-3 py-2 align-items-center"
      key={'notify_' + data.source + '_' + data.id}
    >
      <div className="px-3 text-xs">
        <strong>No new notifications</strong>
      </div>
    </div>
  ) : (
    <>
      <div
        className={`px-2 pt-1 pb-1 align-items-center w-12 border-bottom-1 border-200 ${
          Number(data.is_read) ? 'bg-white' : 'surface-100'
        }`}
        key={'notify_' + data.source + '_' + data.id}
      >
        <div className="grid m-0">
          <div className="col-8 flex text-xs pl-0">
            <i className="pi pi-user mr-2 text-xs"></i>
            <strong>
              {Notifications.SUBTYPEMAPPING[getSubType(data)]}|CX Name:{' '}
              {data.customer_first_name} {data.customer_last_name}
            </strong>
          </div>
          <div className="col-4 flex p-0 w-0 justify-content-end align-items-center">
            <Button
              onClick={() =>
                extra.handleCRMSMSClick(data.sms_response_log_id, 'review')
              }
              label="Review"
              className="text-xs p-1 font-bold bg-transparent focus:shadow-none"
              text
            />
            <Button
              onClick={() =>
                extra.handleCRMSMSClick(data.sms_response_log_id, 'read')
              }
              label="View"
              className="text-xs p-1 font-bold bg-transparent focus:shadow-none ml-2"
              text
            />
          </div>
        </div>
        <div className="text-xs col-12 p-0 pr-2">
          <i className="pi pi-send mr-2 text-xs"></i>
          {ellipsisString(data.response_message, 45)}
        </div>
        <div className="flex px-3 pb-3 text-xs">
          {data.subject && data.subject === null ? (
            <div className="col-12 p-0">Subject: {data.subject}</div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div
        className={`${
          parseInt(data.index) == parseInt(data.length - 1)
            ? 'block  flex justify-content-center surface-200 p-2'
            : 'hidden'
        }`}
      >
        <Button
          size="small"
          outlined
          severity="info"
          className="py-1 px-2"
          onClick={extra.loadMoreSmsHandler}
          disabled={Number(extra.smsCount) === Number(extra.totalSmsCount)}
        >
          Load more
          {extra.SMSLoading ? (
            <i
              className="pi pi-spin pi-spinner ml-2"
              style={{ fontSize: '10px' }}
            ></i>
          ) : (
            ''
          )}
        </Button>
      </div>
    </>
  );
};

export const mapCRMSMSNotificationsList = (
  crmSMSList,
  handleCRMSMSClick,
  loadMoreSmsHandler,
  disabledLoadMore,
  totalSmsCount,
  SMSLoading,
  smsCount
) => {
  const extra = {
    handleCRMSMSClick,
    loadMoreSmsHandler,
    disabledLoadMore,
    totalSmsCount,
    SMSLoading,
    smsCount,
  };
  const data =
    crmSMSList && crmSMSList?.length > 0
      ? crmSMSList?.map((row, index) => {
          const data = {
            isEmpty: false,
            source: 'crm_sms',
            client_id: row?.client_id,
            customer_first_name: row?.customer_first_name,
            customer_last_name: row?.customer_last_name,
            subject: row?.subject,
            sender_number: row?.sender_number,
            project_id: row?.project_id,
            sms_response_log_id: row?.sms_response_log_id,
            is_read: row?.is_read,
            response_message: row?.response_message,
            index: index,
            length: crmSMSList?.length,
            customer_id: row?.customer_id,
            opportunity_id: row?.opportunity_id,
            quote_id: row?.quote_id,
            invoice_id: row?.invoice_id,
            payment_id: row?.payment_id,
          };
          return {
            template: () => {
              return renderSmsTemplate(data, extra);
            },
          };
        })
      : [
          {
            icon: 'pi pi-search',
            label: 'No result found',
          },
        ];
  return data;
};
// #### SMS notification end -----------------

const renderCustomerNotesTemplate = (data, extra) => {
  return data.isEmpty ? (
    <div
      className="flex px-2 py-2 align-items-center"
      key={'notify_' + data.source + '_' + data.id}
    >
      <div className="px-3 text-xs">
        <strong>No new notifications</strong>
      </div>
    </div>
  ) : (
    <>
      <div
        className={`px-2 pt-1 pb-1 align-items-center w-12 border-bottom-1 border-200 ${
          Number(data.is_read) ? 'bg-white' : 'surface-100'
        }`}
        key={'notify_' + data.source + '_' + data.id}
      >
        <div className="grid m-0">
          <div className="col-8 flex text-xs pl-0 align-items-center">
            <i className="pi pi-user mr-2 text-xs"></i>
            <strong>CX Name: {data.customer}</strong>
          </div>
          {checkPermission(permissions.pullDownMenu.customerNotes) && (
            <div className="col-4 flex p-0 w-0 justify-content-end align-items-center">
              <Button
                onClick={() =>
                  extra.handleCustomerNotesClick(
                    data.project_id,
                    data.id,
                    'review'
                  )
                }
                label="Review"
                className="text-xs p-1 font-bold bg-transparent focus:shadow-none ml-2"
                text
              />
              <Button
                onClick={() =>
                  extra.handleCustomerNotesClick(
                    data.project_id,
                    data.id,
                    'read'
                  )
                }
                label="View"
                className="text-xs p-1 font-bold bg-transparent focus:shadow-none"
                text
              />
            </div>
          )}
        </div>
        <div className="text-xs col-12 p-0 pr-2">
          <i className="pi pi-send mr-2 text-xs"></i>
          {ellipsisString(data.note, 45)}
        </div>
      </div>
      {parseInt(data.index) == parseInt(data.length - 1) && (
        <div className="block  flex justify-content-center surface-200 p-2">
          <Button
            size="small"
            outlined
            severity="info"
            className="py-1 px-2"
            onClick={extra.loadMoreCustomerNotesHandler}
            disabled={data.length == extra.totalCustomerNotesCount}
          >
            Load more
            {extra.isLoading ? (
              <i
                className="pi pi-spin pi-spinner ml-2"
                style={{ fontSize: '10px' }}
              ></i>
            ) : (
              ''
            )}
          </Button>
        </div>
      )}
    </>
  );
};

export const mapCustomerNotesList = (
  customerNotesList,
  handleCustomerNotesClick,
  loadMoreCustomerNotesHandler,
  totalCustomerNotesCount,
  customerNotesCount,
  handleCustomeCommunicationLoading,
  isLoading
) => {
  const extra = {
    customerNotesList,
    handleCustomerNotesClick,
    loadMoreCustomerNotesHandler,
    totalCustomerNotesCount,
    customerNotesCount,
    handleCustomeCommunicationLoading,
    isLoading,
  };
  const data =
    customerNotesList && customerNotesList?.length > 0
      ? customerNotesList?.map((row, index) => {
          return {
            template: () => {
              const data = {
                isEmpty: false,
                source: 'customer_notes',
                id: row?.note_id,
                from: row?.name,
                customer: `${row?.customer_first_name} ${row?.customer_last_name}`,
                note: row?.note,
                is_read: row?.is_read,
                project_id: row?.project_id,
                index,
                length: customerNotesCount,
              };
              return renderCustomerNotesTemplate(data, extra);
            },
          };
        })
      : [
          {
            icon: 'pi pi-search',
            label: 'No result found',
          },
        ];
  return data;
};
